import React, { useState } from 'react'
import { Field } from 'react-final-form'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import ContactApi from '@containers/ContactApi/ContactApi'
import Input from '../../components/input/Input/Input'
import { H4 } from '../../components/typography'
import Form from './Form/Form'
import { minLength2Required, requiredEmail, required, requiredUsOrUkPhone } from './validation'

const FormHeading = styled(H4)`
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 30px;
`

const MessageForm = styled(Form)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

const SuccessMessage = styled.div`
  font-weight: 400;
  font-size: 24px;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  text-align: center;
  padding: 3%;
  ${media.sm`
    min-height: 463px;
    top: -10%;
  `}
`

const Close = styled.span`
  color: ${(props) => props.theme.colors.secondary};
  cursor: pointer;
  position: absolute;
  right: 5px;
  top: 5px;
`

const ContactForm = ({
  onCompleted = () => {},
  userMessageHeight,
  successMessage = 'Thank you, a member of our team will be in touch soon.',
  formHeading = 'Message us using the form below',
}) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  return (
    <ContactApi
      onCompleted={() => {
        setShowSuccessMessage(true)
        onCompleted()
      }}
    >
      {(contactUs) => (
        <MessageForm
          title={() => <FormHeading>{formHeading}</FormHeading>}
          onSubmit={contactUs}
          submitMsg="Message Us"
        >
          <Field name="name" component={Input} placeholder="Name*" validate={minLength2Required} />

          <Field name="email" component={Input} placeholder="Email*" validate={requiredEmail} />

          <Field
            name="phone"
            component={Input}
            validate={requiredUsOrUkPhone}
            placeholder="Phone Number*"
          />

          <Field
            name="message"
            render={({ input, meta }) => (
              <Input.TextArea
                {...input}
                placeholder="Your message"
                style={{ height: `${userMessageHeight}` }}
              />
            )}
            validate={required}
          />
          {showSuccessMessage && (
            <SuccessMessage>
              <Close onClick={() => setShowSuccessMessage(false)}>&times;</Close>
              {successMessage}
            </SuccessMessage>
          )}
        </MessageForm>
      )}
    </ContactApi>
  )
}

export default ContactForm
